export default __webpack_public_path__ + "static/media/lincoln-logo.97854a4c.png";